import { qsa } from "@fluorescent/dom";
import {
  FadeUpReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  fadeUp: ".animation-fade-up-reveal",
};

export default node => {
  let observer = null;
  const fadeUpItems = qsa(selectors.fadeUp, node);
  const textReveals = [];

  if (shouldAnimate(node)) {
    fadeUpItems.forEach(item => {
      textReveals.push(new FadeUpReveal(item));
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let textDelay = window.theme.animation.delay;
    textReveals.forEach(reveal => {
      reveal.play(textDelay);
      textDelay += window.theme.animation.delay;
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
